import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import {
  EditAppointment,
  changeAppointmentData,
  deleteWaitList,
  clearAppointmentData,
  getOnsiteAppReq,
  GetUpcomingAppointment,
} from "../../../StateManagement/Reducers/AppointmentsState";

import { toast } from "react-toastify";
import Error from "../../../Modules/StyledComponents/Toastify/Error";

import {
  Div,
  Description,
  Image,
  Button,
  FlexJustCenter,
  Span,
  PageSubTitle,
} from "../../StyledComponents";
import {
  Container,
  CardContainer,
  DateContainer,
  Options,
  CardBody,
  List,
  BackgroundDiv,
  Address,
  CheckinButton,
  Div1,
  Status,
  RespSubTitle,
  RespDiv,
  Ptag,
  ScrollBody,
} from "./styles";

import { AiFillClockCircle, AiOutlinePlus } from "react-icons/ai";
import {
  BiUserCircle,
  BiLocationPlus,
  BiDotsVerticalRounded,
} from "react-icons/bi";
import { RiEditLine, RiDeleteBin7Line } from "react-icons/ri";
import { HiOutlineVideoCamera } from "react-icons/hi";
import AppointmentCancel from "../../Appointment/AppointmentCancel";
import NoAppointmentImage from "../../../Assets/images/no_appt_image.png";
import cardBackground from "../../../Assets/images/card_background.png";
import { InitialsText } from "../AddAppointment/Styles";

const AppointmentsList = ({ onScheduleClick }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [cardOpenId, setCardOpenId] = useState([]);
  const [cancelAppt, setCancelAppt] = useState(false);
  const [CancelDate, setCancelDate] = useState("");
  const [CancelData, setCancelData] = useState("");

  const AppointmentLists = useSelector(
    (state) => state.Appointments.upcomingAppointment,
  );
  const appointmentData = useSelector(
    (state) => state.Appointments.appointmentData,
  );
  const OnsiteAppReq = useSelector((state) => state.Appointments.OnsiteAppReq);

  const setOpenButton = (value) => {
    if (cardOpenId === value) {
      setOpen(false);
      setCardOpenId([]);
    } else {
      setOpen(true);
      setCardOpenId(value);
    }
  };

  const StartVideo = (eventTime, start_url) => {
    let currentDateTime = new Date();
    let eventDateTime = new Date(eventTime);
    if (currentDateTime < eventDateTime) {
      alert(`Your Meeting is scheduled at ${eventTime}`);
      return false;
    }
    window.open(start_url, "_blank");
  };

  const handleClick = (e) => {
    if (inputRef.current && !inputRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const StartEditAppointment = (data) => {
    console.log(data, "compoent data");
    let normalizedData = { ...data };
    // Check if this is a waitlist item
    if (
      normalizedData.pc_apptstatus === "waitlist" || 
      normalizedData.pc_appstatus === "waitlist" || 
      normalizedData.type === "waitlist"
    ) {
      normalizedData.type = "waitlist";
      
      // FIX 1: Map "facility" to "pc_facility" so the Facility dropdown works
      if (normalizedData.facility && !normalizedData.pc_facility) {
        normalizedData.pc_facility = String(normalizedData.facility);
      }

      // FIX 2: Map "appt_type" to "pc_catid" so the Appointment Type dropdown works
      if (normalizedData.appt_type && !normalizedData.pc_catid) {
        normalizedData.pc_catid = String(normalizedData.appt_type);
      }
    }

    // FIX 3: Ensure Provider ID (pc_aid) is ALWAYS a string so React dropdowns don't break
    if (normalizedData.pc_aid) {
      normalizedData.pc_aid = String(normalizedData.pc_aid);
    }

    dispatch(clearAppointmentData(""));

    // Now send the perfectly formatted data to Redux!
    dispatch(EditAppointment(normalizedData));
    //dispatch(EditAppointment(data));
    onScheduleClick();
    // navigate("/appointment/add_appointment");
    setOpen(false);
  };

  const scheduleapp = () => {
    console.log("OnsiteAppReq:", OnsiteAppReq);
    if (parseInt(OnsiteAppReq["allow_portal"]) === 1) {
      if (parseInt(OnsiteAppReq["individual_patient"]) === 0) {
        // navigate("/appointment/add_appointment");
        dispatch(clearAppointmentData(""));
        onScheduleClick();
      } else if (
        parseInt(OnsiteAppReq["individual_patient"]) === 1 &&
        parseInt(OnsiteAppReq["newpat_allow"]) === 1
      ) {
        // navigate("/appointment/add_appointment");
        dispatch(clearAppointmentData(""));
        onScheduleClick();
      } else {
        toast(<Error msg="You're not allow to Make an Appointment" />, {
          containerId: "B",
          className: "error_badge",
        });
      }
    } else {
      toast(<Error msg="You're not allow to Make an Appointment......" />, {
        containerId: "B",
        className: "error_badge",
      });
    }
  };

  useEffect(() => {
    document.addEventListener("mouseup", handleClick);

    dispatch(getOnsiteAppReq());
    dispatch(GetUpcomingAppointment(""));

    return () => {
      document.removeEventListener("mouseup", handleClick);
    };
  }, [dispatch]);

  return (
    <RespDiv width="100%" height="100%" backColor="#FFFFFF" padding="0px">
      {/* <RespSubTitle
        fontWeight="500"
        fontSize="20px"
        lineHeight="25px"
        color="#000000"
      >
        Upcoming Appointments
      </RespSubTitle> */}
      {/* <Description
        fontWeight="400"
        fontSize="14px"
        lineHeight="19px"
        color="#7d8592"
        margin="9px 0px 0px 0px"
      >
        Manage Your Appointment
      </Description> */}
      {/* {!AppointmentLists || AppointmentLists.length === 0 ? (
        <>
          <Image
            loading="lazy"
            src={NoAppointmentImage}
            width="160%"
            height="150%"
            margin="30px auto 40px"
            display="block"
          /> */}

      {/* <Button
            border="1px solid #2C7BE5"
            hoverBackColor="rgba(244, 246, 249, 0.75)"
            borderRadius="4px"
            background="#ffffff"
            color="#2C7BE5"
            padding="12px 20px"
            fontSize="12px"
            lineHeight="18px"
            fontWeight="600"
            width="calc(100% - 36px)"
            className="close_active"
            onClick={scheduleapp}
          >
            <AiOutlinePlus
              viewBox="150 -60 900 900"
              width="12"
              height="12"
              margin="0 10px"
            />
            Schedule Appointment
          </Button> */}
      {/* </>
      ) : ( */}
      <Container open={open}>
        {/* {AppointmentLists.length > 0 && (
            <>
              {AppointmentLists.map((lists, index) => (
                <CardContainer
                  accept={lists.accept}
                  index={index}
                  background={`url(${cardBackground})`}
                >
                  <FlexJustCenter>
                    <DateContainer
                      fontSize={lists.pc_recurrtype === "0" ? "20px" : "12px"}
                      index={index}
                      accept={lists.accept}
                    >
                      {lists.pc_recurrtype === "0"
                        ? lists.pc_eventDate
                        : moment(lists.ApptFromDate).format(
                            "dddd DD MMM YYYY",
                          ) +
                          " - " +
                          moment(lists.pc_endDate).format("dddd DD MMM YYYY")}
                    </DateContainer>
                    {lists.accept !== "2" &&
                      lists.accept !== 2 &&
                      lists.accept !== "3" && (
                        <Options
                          index={index}
                          accept={lists.accept}
                          onClick={(e) => {
                            setOpenButton(lists.pc_eid);
                          }}
                        >
                          <BiDotsVerticalRounded />
                        </Options>
                      )}
                  </FlexJustCenter>
                  {cardOpenId === lists.pc_eid && (
                    <Div1 ref={inputRef} display={open} right="-6px">
                      {lists.pc_recurrtype === "0" && (
                        <Button
                          color="#414141"
                          display="block"
                          family="'Inter'"
                          fontWeight="400"
                          fontSize="14px"
                          lineHeight="16px"
                          padding="8px 52px 8px 16px"
                          background="#ffffff"
                          textAlign="left"
                          width="100%"
                          hoverBackColor="#FAFAFA"
                          disabled={
                            lists.accept === "2" ||
                            lists.accept === "3" ||
                            lists.pc_recurrtype !== "0"
                          }
                          onClick={() => StartEditAppointment(lists)}
                        >
                          <RiEditLine marginRight="14px" />
                          <Span marginLeft="14px">Edit</Span>
                        </Button>
                      )}
                      <Button
                        color="#414141"
                        display="flex"
                        family="'Inter'"
                        fontWeight="400"
                        fontSize="14px"
                        lineHeight="16px"
                        padding="8px 52px 8px 16px"
                        background="#ffffff"
                        hoverBackColor="#FAFAFA"
                        width="100%"
                        disabled={
                          lists.pc_apptstatus === "@" ||
                          lists.pc_apptstatus === "doc_completed" ||
                          appointmentData["eid"] === lists.pc_eid ||
                          lists.accept === "2" ||
                          lists.accept === "3"
                        }
                        onClick={() => {
                          if (lists.type !== "waitlist") {
                            setCancelAppt(true);
                            setCancelDate(
                              moment(lists.ApptFromDate).format("Y-MM-DD"),
                            );
                            setCancelData(lists);
                            dispatch(
                              changeAppointmentData({
                                name: "cancelID",
                                value: lists.pc_eid,
                              }),
                            );
                            setOpen(false);
                          }

                          if (lists.type === "waitlist") {
                            if (
                              window.confirm(
                                "Are you sure you want to delete this waitlist?",
                              )
                            ) {
                              dispatch(deleteWaitList(lists.pc_eid));
                            }
                          }
                        }}
                      >
                        <RiDeleteBin7Line marginRight="14px" />
                        <Span marginLeft="14px">Cancel</Span>
                      </Button>
                    </Div1>
                  )}
                  <CardBody index={index} accept={lists.accept}>
                    <List style={{ display: "flex", alignItems: "flex-start" }}>
                      <div style={{ width: "10%" }}>
                        <BackgroundDiv
                          index={index}
                          accept={lists.accept}
                          style={{ width: "24px", height: "24px" }}
                        >
                          <BiUserCircle />
                        </BackgroundDiv>
                      </div>
                      <div
                        title={lists.provider_name}
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                          lineHeight: "1.2",
                          fontSize: "14px",
                          maxWidth: "90%",
                          marginTop: "16px",
                        }}
                      >
                        {lists.provider_name}
                      </div>
                    </List>
                    <List display="flex">
                      <div style={{ width: "10%" }}>
                        <BackgroundDiv
                          index={index}
                          accept={lists.accept}
                          style={{ width: "24px", height: "24px" }}
                        >
                          <AiFillClockCircle />
                        </BackgroundDiv>
                      </div>
                      <Ptag
                        title={lists.provider_name}
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                          lineHeight: "1.2",
                          fontSize: "14px",
                          maxWidth: "80%",
                          marginTop: "16px",
                        }}
                      >
                        {lists.duration}
                      </Ptag>
                    </List>
                    <List style={{ display: "flex" }}>
                      <div style={{ width: "10%" }}>
                        <BackgroundDiv
                          index={index}
                          accept={lists.accept}
                          style={{ width: "24px", height: "24px" }}
                        >
                          <BiLocationPlus />
                        </BackgroundDiv>
                      </div>
                      {lists.tele_health === "1" ? (
                        <div
                          title={lists.facility_name}
                          style={{
                            wordBreak: "normal",
                            whiteSpace: "normal",
                            lineHeight: "1.2",
                            fontSize: "14px",
                            maxWidth: "80%",
                            marginTop: "14px",
                          }}
                        >
                          Telehealth
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "12px",
                            maxWidth: "80%",
                          }}
                        >
                          <div
                            title={lists.facility_name}
                            style={{
                              wordBreak: "normal",
                              whiteSpace: "normal",
                              lineHeight: "1.2",
                              fontSize: "14px",
                              maxWidth: "80%",
                            }}
                          >
                            {lists.facility_name}
                          </div>

                          <Address
                            index={index}
                            accept={lists.accept}
                            style={{ marginLeft: "0px" }}
                          >
                            {lists.facility_address}
                          </Address>
                        </div>
                      )}
                    </List>
                  </CardBody>
                  {lists.accept === "0" && (
                    <Status accept={lists.accept}>Appointment request </Status>
                  )}
                  {lists.type === "waitlist" &&
                    (lists.accept === "0" || lists.accept === 0) && (
                      <Status accept={lists.accept}>
                        WaitList Appointment{" "}
                      </Status>
                    )}
                  {lists.type === "waitlist" &&
                    (lists.accept === "1" || lists.accept === 1) && (
                      <CheckinButton index={index}>
                        WaitList Appointment Confirmed{" "}
                      </CheckinButton>
                    )}
                  {lists.type === "waitlist" &&
                    (lists.accept === "2" || lists.accept === 2) && (
                      <Status accept={lists.accept}>
                        Cancelled WaitList Appointment{" "}
                      </Status>
                    )}
                  {lists.accept === "1" &&
                    lists.tele_health === "1" &&
                    index === 0 && (
                      <CheckinButton
                        index={index}
                        onClick={() =>
                          StartVideo(lists.eventDateTime, lists.start_url)
                        }
                      >
                        <BackgroundDiv index={index} tag="button">
                          <HiOutlineVideoCamera />
                        </BackgroundDiv>
                        <Span marginLeft="8px">Join Telehealth</Span>
                      </CheckinButton>
                    )}

                  {lists.accept === "1" &&
                    lists.tele_health === "1" &&
                    index > 0 && (
                      <Status accept={lists.accept}>Join Telehealth </Status>
                    )}
                  {lists.accept === "1" &&
                    lists.tele_health === "0" &&
                    index === 0 && (
                      <CheckinButton index={index}>
                        Appointment Confirmed
                      </CheckinButton>
                    )}
                  {lists.accept === "1" &&
                    lists.type !== "waitlist" &&
                    lists.tele_health === "0" &&
                    index >= 1 && (
                      <Status accept={lists.accept}>
                        Appointment Confirmed{" "}
                      </Status>
                    )}
                  {lists.accept === "2" && lists.type !== "waitlist" && (
                    <Status accept={lists.accept}>Cancelled </Status>
                  )}
                </CardContainer>
              ))} */}
        {/* </>
          )} */}
        <div
          style={{
            background: "#ffffff",
            padding: "6px 20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "6px",
            marginBottom: "2px",
          }}
        >
          <div
            style={{
              color: "#2E2E2E",
              fontWeight: "600",
              fontSize: "20px",
            }}
          >
            Appointment List
          </div>

          <button
            onClick={scheduleapp}
            style={{
              background: "#407BFF",
              color: "#FFFFFF",
              border: "none",
              padding: "9px 10px",
              borderRadius: "6px",
              fontWeight: "500",
              fontSize: "13px",
              cursor: "pointer",
            }}
            onMouseOver={(e) => (e.target.style.background = "#2C6EF2")}
            onMouseOut={(e) => (e.target.style.background = "#407BFF")}
          >
            Schedule Appointment
          </button>
        </div>
        <div
          style={{
            width: "100%",
            margin: 0,
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
          }}
        >
          <div
            style={{
              display: "grid",
              background: "#F1F5F8",
              gridTemplateColumns:
                "minmax(180px, 1.5fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(140px, 1fr) minmax(140px, 1fr) minmax(120px, 1fr) 110px",
              width: "100%",
              padding: "12px 20px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#407BFF",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            <div>Provider</div>
            <div>Date</div>
            <div>Time</div>
            <div>Facility</div>
            <div>Appointment Type</div>
            <div>Status</div>
            <div>Action</div>
          </div>
          <ScrollBody>
            {!AppointmentLists || AppointmentLists.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "260px",
                }}
              >
                <Image
                  loading="lazy"
                  src={NoAppointmentImage}
                  height="230px"
                  width="308px"
                />
              </div>
            ) : (
              AppointmentLists.map((lists, index) => {
                const apptStatus = String(
                  lists.pc_apptstatus ||
                    lists.pc_appstatus ||
                    lists.appointment_status ||
                    lists.status ||
                    "",
                )
                  .trim()
                  .toLowerCase();

                const acceptStatus = String(lists.accept ?? "").trim();

                const isProviderCancelled =
                  apptStatus === "doc_cancelled" ||
                  apptStatus === "cancelled" ||
                  apptStatus === "canceled" ||
                  apptStatus === "cancel" ||
                  apptStatus === "x";

                const isCompleted =
                  apptStatus === "doc_completed" ||
                  apptStatus === "completed" ||
                  apptStatus === "complete" ||
                  apptStatus === "@";

                const isRequested =
                  !isProviderCancelled &&
                  !isCompleted &&
                  (apptStatus === "not_confirmed" ||
                    apptStatus === "pending" ||
                    apptStatus === "requested" ||
                    acceptStatus === "0");

                const isConfirmed =
                  !isProviderCancelled &&
                  !isCompleted &&
                  !isRequested &&
                  (apptStatus === "doc_confirmed" ||
                    apptStatus === "confirmed" ||
                    acceptStatus === "1");

                const isCancelled = isProviderCancelled || acceptStatus === "2";

                // const isTelehealth = lists.tele_health === "1";
                const isTelehealth =
                  lists.tele_health === "1" || lists.appt_type === 2;
                const isWaitlist = lists.type === "waitlist";

                return (
                  <div
                    key={lists.pc_eid}
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "minmax(180px, 1.5fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(140px, 1fr) minmax(140px, 1fr) minmax(120px, 1fr) 110px",
                      width: "100%",
                      padding: "14px 20px",
                      alignItems: "center",
                      // borderBottom: "1px solid #F1F1F1",
                      fontSize: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                      }}
                    >
                      <InitialsText
                        margin="2px 6px 0 0"
                        padding="3px 6px"
                        height="28px"
                        width="28px"
                        fontSize="12px"
                      >
                        {lists.provider_name?.charAt(0)}
                      </InitialsText>

                      <span style={{ fontSize: "12px", fontWeight: "600" }}>
                        {lists.provider_name}
                      </span>
                    </div>

                    <div>{lists.pc_eventDate}</div>
                    <div>
                      {lists.duration?.split("-").slice(0, 2).join("-")}
                    </div>

                    <div>{lists.facility_name}</div>
                    <div>{isTelehealth ? "Telehealth" : "Appointment"}</div>

                    <div>
                      {isCompleted && (
                        <span
                          style={{
                            background: "#D1FAE5",
                            color: "#10B981",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Completed
                        </span>
                    )}
                      {isConfirmed && (
                        <span
                          style={{
                            background: "#2C7BE51A",
                            color: "#2C7BE5",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Confirmed
                        </span>
                      )}

                      {(isRequested ||
                        (isWaitlist && !isConfirmed && !isCancelled)) && (
                        <span
                          style={{
                            background: "#E5E7EB",
                            color: "#6B7280",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          {isWaitlist ? "Waitlist" : "Requested"}
                        </span>
                      )}

                      {isCancelled && (
                        <span
                          style={{
                            background: "#FEE2E2",
                            color: "#EF4444",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Cancelled
                        </span>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      {isConfirmed && isTelehealth && (
                        <HiOutlineVideoCamera
                          size={20}
                          style={{ cursor: "pointer", color: "#119921" }}
                          onClick={() =>
                            StartVideo(lists.eventDateTime, lists.start_url)
                          }
                        />
                      )}

                      {!isCancelled && !isCompleted && (
                        <RiEditLine
                          size={16}
                          style={{ cursor: "pointer", color: "#2C7BE5" }}
                          onClick={() => StartEditAppointment(lists)}
                        />
                      )}

                      {!isCancelled && !isCompleted && (
                        <RiDeleteBin7Line
                          size={16}
                          style={{ cursor: "pointer", color: "#E23D28" }}
                          onClick={() => {
                            setCancelAppt(true);
                            setCancelDate(
                              moment(lists.ApptFromDate).format("Y-MM-DD"),
                            );
                            setCancelData(lists);
                            dispatch(
                              changeAppointmentData({
                                name: "cancelID",
                                value: lists.pc_eid,
                              }),
                            );
                          }}
                        />
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </ScrollBody>
        </div>
      </Container>
      {/* )} */}

      {cancelAppt && (
        <AppointmentCancel
          show={cancelAppt}
          CancelDate={CancelDate}
          CancelData={CancelData}
          HidePopup={() => {
            setCancelAppt(false);
            dispatch(
              changeAppointmentData({
                name: "cancelID",
                value: "",
              }),
            );
          }}
        />
      )}
    </RespDiv>
  );
};

export default AppointmentsList;
